import { Icon } from "@iconify/react";
import { IconButton, Tooltip } from "@mui/material";
import { toPng } from "html-to-image";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const DownloadComponentButton = forwardRef(({ filename, visibility }, ref) => {
  const { t } = useTranslation();
  const download = (ref, filename) => {
    if (ref.current) {
      toPng(ref.current)
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.href = dataUrl;
          link.download = filename;
          link.click();
        })
        .catch((error) => {
          console.error("Error generating image:", error);
        });
    }
  };
  return (
    <Tooltip title={t("Download")}>
      <IconButton
        onClick={() => download(ref, filename)}
        sx={{ display: visibility ? "block" : "none", padding: 0, color: "#999999", "&:hover": { color: "black", backgroundColor: "transparent" } }}>
        <Icon icon="fe:download" style={{ color: "inherit", height: "15px" }} />
      </IconButton>
    </Tooltip>
  );
});

export default DownloadComponentButton;
